import LFCDialogTitle from '_components/feedback/LFCDialogTitle';
import LFCButton from '_components/inputs/LFCButton';
import LFCNumberField from '_components/inputs/LFCNumberField';
import LFCSelectForm from '_components/inputs/LFCSelectForm';
import LFCTextField from '_components/inputs/LFCTextField';
import {handleInputChange, handleInputChange2, setLFCDataMulti} from '_logics/LFCUtil';
import axios from 'axios';
import {useSnackbar} from 'notistack';
import {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {Dialog, DialogActions, DialogContent, Grid, Typography} from '@mui/material';

// 会社が利用しうる AWS region（m_company.region / Cognito custom:region と対応）
export const SUPPORTED_REGIONS = [
  {name: 'ap-northeast-1', value: 'ap-northeast-1'},
  {name: 'ap-south-1', value: 'ap-south-1'},
  {name: 'us-east-1', value: 'us-east-1'}
];
export const DEFAULT_REGION = 'ap-northeast-1';

export type editMode = 'None' | 'AddNew' | 'Modify';
export type rowData = {
  mode: editMode;
  id: string;
  company_id: string;
  company_name: string;
  region: string;
  account_limit: string;
};
export const emptyRowData: rowData = {
  mode: 'None',
  id: '',
  company_id: '',
  company_name: '',
  region: DEFAULT_REGION,
  account_limit: '1'
};

interface Props {
  open: boolean;
  onClose: () => void;
  row: rowData;
}

const CompanyMasterDetailDlg = (props: Props) => {
  const {t} = useTranslation();
  const formRef = useRef<HTMLFormElement>(null!);
  const [values, setValues] = useState<rowData>(emptyRowData);
  const {enqueueSnackbar} = useSnackbar();
  const [source] = useState(axios.CancelToken.source());

  // 保存ボタン押下時
  const onSaveClick = async () => {
    if (!formRef.current?.reportValidity()) {
      return;
    }

    switch (values.mode) {
      case 'AddNew':
        await setLFCDataMulti({
          snack: enqueueSnackbar,
          sql_id: 5000,
          parameters: {
            p_company_id: values.company_id,
            company_name: values.company_name,
            region: values.region,
            account_limit: values.account_limit
          },
          name: `${t('会社マスタの新規登録')}`,
          cancelToken: source.token,
          t
        });
        props.onClose();
        break;
      case 'Modify':
        await setLFCDataMulti({
          snack: enqueueSnackbar,
          sql_id: 5001,
          parameters: {
            p_company_id: values.company_id,
            company_name: values.company_name,
            region: values.region,
            account_limit: values.account_limit
          },
          name: `${t('会社マスタの更新')}`,
          cancelToken: source.token,
          t
        });
        props.onClose();
        break;
    }
  };

  useEffect(() => {
    props.open && setValues(props.row);
  }, [props.open]);

  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth={'sm'}>
      <LFCDialogTitle onClose={props.onClose}>
        {values.mode === 'AddNew' ? t('新規登録') : t('変更')}
      </LFCDialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle1">{t('message.登録内容を入力してください')}</Typography>
          </Grid>
          <Grid item xs={12}>
            <form ref={formRef}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <LFCNumberField
                    name="company_id"
                    label={t('会社ID')}
                    value={values?.company_id}
                    onChange={event => {
                      handleInputChange(event, values, setValues);
                    }}
                    required
                    fullWidth
                    disabled={values.mode === 'AddNew' ? false : true}
                  />
                </Grid>
                <Grid item xs={12}>
                  <LFCTextField
                    name="company_name"
                    label={t('会社名')}
                    value={values?.company_name}
                    onChange={event => {
                      handleInputChange(event, values, setValues);
                    }}
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <LFCSelectForm
                    id="region"
                    name="region"
                    label={'Region'}
                    value={values?.region}
                    onChange={event => {
                      handleInputChange2(event, values, setValues);
                    }}
                    selectItem={SUPPORTED_REGIONS}
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <LFCNumberField
                    name="account_limit"
                    label={t('アカウント上限数')}
                    value={values?.account_limit}
                    onChange={event => {
                      handleInputChange(event, values, setValues);
                    }}
                    min={1}
                    max={99999}
                    required
                    fullWidth
                  />
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <LFCButton onClick={props.onClose}>{t('キャンセル')}</LFCButton>
        <LFCButton color="primary" onClick={onSaveClick}>
          {t('保存')}
        </LFCButton>
      </DialogActions>
    </Dialog>
  );
};
export default CompanyMasterDetailDlg;
